var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhysiology(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 24V23C16 21.8954 16.8954 21 18 21H22.5C23.3284 21 24 20.3284 24 19.5V19.5C24 18.6716 23.3284 18 22.5 18H9.5C8.67157 18 8 17.3284 8 16.5V16.5C8 15.6716 8.67157 15 9.5 15H22.5C23.3284 15 24 14.3284 24 13.5V13.5C24 12.6716 23.3284 12 22.5 12H9.5C8.67157 12 8 11.3284 8 10.5V10.5C8 9.67157 8.67157 9 9.5 9H24",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhysiology);
export default __webpack_public_path__ + "static/media/Physiology.78e15628fc98043c37ca07708fcafb0e.svg";
export { ForwardRef as ReactComponent };